import { micromodal } from "micromodal";

export function drawer() {
  MicroModal.init();

  const buttons = document.querySelectorAll(".js-drawerButton");
  const closeButtons = document.querySelectorAll(".js-drawerClose");
  const header = document.getElementById("js-header");

  const openDrawer = (button, modal) => {
    button.setAttribute("aria-expanded", "true");
    MicroModal.show(modal, {
      disableScroll: true, // ページスクロールを無効に
      awaitOpenAnimation: true, // 開閉時のアニメーションを可能に
    });
    header.classList.add("is-open");
  };

  const closeDrawer = (button, modal) => {
    button.setAttribute("aria-expanded", "false");
    MicroModal.close(modal, {
      awaitCloseAnimation: true,
    });
    header.classList.remove("is-open");
  };

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const modal = button.nextElementSibling.id;
      const currentAriaExpanded = button.getAttribute("aria-expanded");

      if (currentAriaExpanded === "false") {
        openDrawer(button, modal);
      } else {
        closeDrawer(button, modal);
      }
    });
  });

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener("click", () => {
      const drawer = closeButton.closest(".c-drawer");
      const button = drawer.querySelector(".js-drawerButton");
      const modal = drawer.querySelector(".c-drawer__modal").id;
      closeDrawer(button, modal);
    });
  });
}